/**
 * HOCHZEIT RÜCKSEITE – Erweiterung für hochzeit-preview.js („Ja, ich will"-Topf)
 * Gleiches Prinzip wie designer-rueckseite.js: Reiter „Vorderseite / Rückseite" in der
 * Vorschau, Schalter + drei Textzeilen dort, Aufpreis über die Varianten-Option
 * „Rückseite" (ohne / mit), Texte als Eigenschaften „Rückseite Zeile 1–3".
 */
(function () {
  'use strict';

  var LINES = ['hz-back-line1', 'hz-back-line2', 'hz-back-line3'];
  var OPTION = window.HZ_RUECKSEITE_OPTION || 'Rückseite';

  function $(id) { return document.getElementById(id); }

  // hochzeit-preview.js legt HochzeitPreview als const an (kein window-Property)
  function DP() {
    try { return HochzeitPreview; } catch (e) { return window.HochzeitPreview; }
  }

  function aktiv() {
    var t = $('hz-back-toggle');
    return !!(t && t.checked);
  }

  function optionSelect() {
    return document.querySelector('select[name="options[' + OPTION + ']"]');
  }

  // ---------- Eigenschaften synchronisieren
  function syncHidden() {
    var an = aktiv();
    var flag = $('hz-hidden-back');
    if (flag) { flag.value = an ? 'Ja' : ''; flag.disabled = !an; }
    LINES.forEach(function (id, i) {
      var h = $('hz-hidden-back-line' + (i + 1));
      if (h) { h.value = an ? (($(id) || {}).value || '') : ''; h.disabled = !an; }
    });
  }


  // ---------- Hinweis am Preis: „Komplettset · Vorder- und Rückseite graviert"
  function hinweisAktualisieren() {
    var preis = document.querySelector('.product__price-and-ratings') || document.querySelector('.product__price');
    if (!preis) { return; }
    var el = document.getElementById('nm-konfig-hinweis');
    if (!el) {
      el = document.createElement('div');
      el.id = 'nm-konfig-hinweis';
      el.style.cssText = 'font-size:13px;color:#115E16;margin:2px 0 6px;font-weight:600;';
      preis.parentNode.insertBefore(el, preis.nextSibling);
    }
    var ausf = document.querySelector('select[name="options[Ausführung]"]');
    var ausfText = ausf ? ausf.value : '';
    el.textContent = (ausfText ? ausfText + ' · ' : '') + (aktiv() ? 'Vorder- und Rückseite graviert (+ 8,00 €)' : 'nur Vorderseite graviert');
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('select[name^="options["]')) { setTimeout(hinweisAktualisieren, 50); }
  }, true);

  // ---------- Variante umschalten (Theme aktualisiert Preis/Variante selbst)
  function varianteSetzen() {
    var sel = optionSelect();
    if (!sel) { return; }
    var werte = Array.prototype.map.call(sel.options, function (o) { return o.value; });
    var ziel = aktiv() ? (werte.find(function (w) { return /mit/i.test(w); }) || werte[1]) : werte[0];
    if (!ziel || sel.value === ziel) { return; }
    sel.value = ziel;
    sel.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
  }

  function kachelWechselAbfangen() {
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) { return; }
      if (!e.target.closest('.variant-option-card')) { return; }
      setTimeout(varianteSetzen, 60);
      setTimeout(varianteSetzen, 400);
    }, true);
  }

  // ---------- Vorschau: Rückseite zeichnen
  var currentSide = 'front';

  async function renderBack() {
    var dp = DP();
    if (!dp || !dp.ctx || dp.isRendering) { return; }
    dp.isRendering = true;
    try {
      if (dp.fontsLoaded === false && typeof dp.loadFonts === 'function') { await dp.loadFonts(); }
      var W = dp.config.canvasWidth || 800, H = dp.config.canvasHeight || 800;
      dp.ctx.clearRect(0, 0, W, H);
      if (dp.images.base && dp.images.base.complete) { dp.ctx.drawImage(dp.images.base, 0, 0, W, H); }
      var texte = LINES.map(function (id) { return (($(id) || {}).value || '').trim(); }).filter(function (t) { return t; });
      var cfg = dp.config.textConfig.vornamen;          // Schrift der Vornamen (Lovely), ~20 % kleiner
      dp.ctx.textAlign = 'center';
      dp.ctx.textBaseline = 'middle';
      if (!texte.length || !aktiv()) {
        dp.ctx.font = '30px "Montserrat", sans-serif';
        dp.ctx.fillStyle = '#9aa39b';
        dp.ctx.fillText(aktiv() ? 'Rückseite: noch kein Text' : 'Rückseite ohne Gravur', 400, 560);
        return;
      }
      try { await document.fonts.load('500 40px "Outfit"'); } catch (e) {}
      var size = 40;                                      // schlichte Schrift, Rückseite (Taras 28.09.)
      var abstand = 54;
      var y0 = 560 - ((texte.length - 1) * abstand) / 2;
      dp.ctx.fillStyle = cfg.color;
      dp.ctx.font = '500 ' + size + 'px "Outfit", sans-serif';   // Taras 28.09.: Outfit
      texte.forEach(function (t, i) { dp.ctx.fillText(t, cfg.x, y0 + i * abstand); });
    } catch (e) {
      console.error('HZ Rückseite rendern:', e);
    } finally {
      dp.isRendering = false;
    }
  }

  function showSide(side) {
    var dp = DP();
    currentSide = side;
    document.querySelectorAll('#hz-side-tabs button').forEach(function (b) { b.classList.toggle('active', b.dataset.side === side); });
    var felder = $('hz-back-fields');
    if (felder) { felder.style.display = (side === 'back') ? 'block' : 'none'; }
    if (!dp) { return; }
    if (side === 'back') { renderBack(); } else if (typeof dp.renderPreview === 'function') { dp.renderPreview(); }
  }

  function toggleFields() {
    var box = $('hz-back-fields');
    if (box) { box.classList.toggle('aus', !aktiv()); }
    syncHidden();
    varianteSetzen();
    setTimeout(hinweisAktualisieren, 80);
    if (currentSide === 'back') { renderBack(); }
  }


  // ---------- Beim (Wieder-)Laden immer ohne Rückseite starten (01.10.2026)
  // Browser stellen beim Zurückgehen/Neuladen das Häkchen wieder her, die Textfelder
  // im Vorschau-Fenster aber nicht -> „mit Rückseite" war vorausgewählt, aber leer.
  // Nichts merken: Rückseite immer aus und leer, Kunde gibt sie bei Bedarf neu ein.
  var nutzerHatEingegeben = false;
  document.addEventListener('input', function (e) { if (e.isTrusted) { nutzerHatEingegeben = true; } }, true);
  document.addEventListener('change', function (e) { if (e.isTrusted) { nutzerHatEingegeben = true; } }, true);

  function zuruecksetzen() {
    var t = $('hz-back-toggle');
    if (t) { t.checked = false; }
    LINES.forEach(function (id) { var el = $(id); if (el) { el.value = ''; } });
    toggleFields();
  }

  // ---------- Start
  function init() {
    var toggle = $('hz-back-toggle');
    if (!toggle) { return; }
    if (!optionSelect()) {                       // Produkt ohne Option „Rückseite": nichts anbieten
      var t0 = $('hz-side-tabs'); if (t0) { t0.remove(); }
      var b0 = $('hz-back-fields'); if (b0) { b0.remove(); }
      return;
    }
    toggle.addEventListener('change', toggleFields);
    LINES.forEach(function (id) {
      var el = $(id);
      if (!el) { return; }
      el.addEventListener('input', function () {
        var t = $('hz-back-toggle');
        if (t && !t.checked && el.value.trim()) { t.checked = true; toggleFields(); return; }
        syncHidden();
        if (currentSide === 'back') { renderBack(); }
      });
    });
    document.querySelectorAll('#hz-side-tabs button').forEach(function (b) {
      b.addEventListener('click', function () { showSide(b.dataset.side); });
    });
    var previewBtn = $('hz-preview-btn');
    if (previewBtn) {
      // Nur den Reiter-Zustand zurücksetzen – NICHT rendern, sonst blockiert isRendering
      // das openPreview() von hochzeit-preview.js (läuft im selben Klick).
      previewBtn.addEventListener('click', function () {
        currentSide = 'front';
        document.querySelectorAll('#hz-side-tabs button').forEach(function (b) { b.classList.toggle('active', b.dataset.side === 'front'); });
        var felder = $('hz-back-fields'); if (felder) { felder.style.display = 'none'; }
      });
    }
    // Eigenschaften-Reihenfolge im Warenkorb: erst Vornamen/Datum/Motiv, dann Rückseite.
    // hochzeit-preview.js verschiebt seine Felder später ins Formular – deshalb unsere
    // Felder immer direkt HINTER das Motiv-Feld hängen (beim Start und vor dem Absenden).
    function reihenfolgeSichern() {
      var form = document.querySelector('form[action*="/cart/add"]');
      if (!form) { return; }
      var anker = $('hz-hidden-motiv');
      var ziel = (anker && form.contains(anker)) ? anker : null;
      ['hz-hidden-back', 'hz-hidden-back-line1', 'hz-hidden-back-line2', 'hz-hidden-back-line3'].forEach(function (id) {
        var f = $(id);
        if (!f) { return; }
        if (ziel) { ziel.insertAdjacentElement('afterend', f); ziel = f; } else if (!form.contains(f)) { form.appendChild(f); }
      });
    }
    reihenfolgeSichern();
    setTimeout(reihenfolgeSichern, 1500);
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) { form.addEventListener('submit', reihenfolgeSichern, true); }
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-add-to-cart], .preview-add-to-cart-btn, form[action*="/cart/add"] button[type=submit]')) { reihenfolgeSichern(); }
    }, true);
    kachelWechselAbfangen();
    zuruecksetzen();
    // Manche Browser füllen Formulare erst nach DOMContentLoaded wieder auf
    window.addEventListener('load', function () { if (!nutzerHatEingegeben) { zuruecksetzen(); } });
    // Seite aus dem Zurück-Cache (bfcache): Zustand stammt vom letzten Besuch
    window.addEventListener('pageshow', function (e) { if (e.persisted) { zuruecksetzen(); } });
    setTimeout(hinweisAktualisieren, 600);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
